function initVariantDescriptions() {
  /*
    -----------------------------
    VARIANT AUTO-SELECTION LOGIC
    -----------------------------
    COMMENTED OUT: restore normal Shopify default variant selection
    (selected_or_first_available_variant / ?variant= URL param).
    Uncomment this block to re-enable medium + firm + queen auto-select.
  */

  function getCurrentVariantInput() {
    return (
      document.querySelector('form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('[name="id"]')
    );
  }

  function getCurrentVariantId() {
    const variantInput = getCurrentVariantInput();
    return variantInput ? variantInput.value : null;
  }

  /*
  function getProductVariants() {
    const productJsonScript = document.querySelector('[data-product-json]');

    if (!productJsonScript) {
      console.log("Product JSON not found");
      return [];
    }

    try {
      const productData = JSON.parse(productJsonScript.textContent);

      if (!productData.variants) {
        console.log("No variants in product JSON");
        return [];
      }

      return productData.variants;
    } catch (e) {
      console.log("Product JSON parse error", e);
      return [];
    }
  }

  // TARGET MATCH:
  // PRIORITY 1 = medium + firm + queen
  // PRIORITY 2 = medium + queen
  function isExactTargetVariant(variant) {
    if (!variant) return false;

    const normalizedText = [
      variant.title,
      variant.option1,
      variant.option2,
      variant.option3
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase()
      .replace(/-/g, " ")
      .replace(/\//g, " ")
      .replace(/\s+/g, " ")
      .trim();

    return (
      normalizedText.includes("medium") &&
      normalizedText.includes("firm") &&
      normalizedText.includes("queen")
    );
  }

  function isFallbackTargetVariant(variant) {
    if (!variant) return false;

    const normalizedText = [
      variant.title,
      variant.option1,
      variant.option2,
      variant.option3
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase()
      .replace(/-/g, " ")
      .replace(/\//g, " ")
      .replace(/\s+/g, " ")
      .trim();

    return (
      normalizedText.includes("medium") &&
      normalizedText.includes("queen")
    );
  }

  function autoSelectSecondOrFirstAvailableVariant() {
    const currentVariantId = getCurrentVariantId();

    const variants = getProductVariants();

    if (!variants.length) {
      return;
    }

    const currentVariant = variants.find(
      variant => String(variant.id) === String(currentVariantId)
    );

    if (isExactTargetVariant(currentVariant)) {
      return;
    }

    let targetVariant = null;

    // PRIORITY 1: EXACT medium + firm + queen
    targetVariant = variants.find(
      variant =>
        variant.available &&
        isExactTargetVariant(variant)
    );

    // PRIORITY 2: medium + queen fallback
    if (!targetVariant) {
      targetVariant = variants.find(
        variant =>
          variant.available &&
          isFallbackTargetVariant(variant)
      );
    }

    if (!targetVariant) {
      return;
    }

    // Prevent redirect loop
    if (String(currentVariantId) === String(targetVariant.id)) {
      return;
    }

    const url = new URL(window.location.href);

    url.searchParams.set("variant", targetVariant.id);

    window.location.replace(url.toString());
  }
  */

  /*
    -----------------------------
    VARIANT DESCRIPTION LOGIC
    -----------------------------
    Fully optional
  */

  const variantDescriptionContainer = document.querySelector('[data-variant-description]');
  const variantDescriptionsScript = document.querySelector('[data-variant-descriptions-json]');

  let variantDescriptions = {};
  let lastVariantId = null;

  function updateVariantDescription(variantId) {
    /*
      If description elements missing, silently skip
    */
    if (!variantDescriptionContainer || !variantDescriptionsScript) {
      return;
    }

    if (!variantId) return;

    if (String(variantId) === String(lastVariantId)) {
      return;
    }

    lastVariantId = String(variantId);

    const description = variantDescriptions[lastVariantId];

    if (description && description.trim() !== "") {
      variantDescriptionContainer.innerHTML = description;
      variantDescriptionContainer.style.display = "block";
    } else {
      variantDescriptionContainer.innerHTML = "";
      variantDescriptionContainer.style.display = "none";
    }
  }

  /*
    SAFE DESCRIPTION JSON PARSE
  */
  if (variantDescriptionContainer && variantDescriptionsScript) {
    try {
      variantDescriptions = JSON.parse(variantDescriptionsScript.textContent);
    } catch (e) {
      console.log("Variant descriptions JSON parse error", e);
    }

    /*
      VARIANT CHANGE LISTENER
    */
    document.addEventListener("change", function(event) {
      if (event.target.matches('[name="id"]')) {
        updateVariantDescription(event.target.value);
      }
    });

    /*
      SHOPIFY CUSTOM VARIANT EVENT
    */
    document.addEventListener("variant:change", function(event) {
      if (event.detail?.variant?.id) {
        updateVariantDescription(event.detail.variant.id);
      }
    });

    /*
      LIGHT OBSERVER
    */
    const variantInput = getCurrentVariantInput();

    if (variantInput) {
      const observer = new MutationObserver(() => {
        updateVariantDescription(getCurrentVariantId());
      });

      observer.observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });
    }
  }

  /*
    -----------------------------
    INIT
    -----------------------------
  */
  requestAnimationFrame(() => {
    /*
      COMMENTED OUT: medium/queen auto-select — use normal Shopify variant selection
    */
    // autoSelectSecondOrFirstAvailableVariant();

    /*
      Description only if available
    */
    const currentVariantId = getCurrentVariantId();

    if (currentVariantId) {
      updateVariantDescription(currentVariantId);
    }
  });
}

/*
  INITIAL PAGE LOAD
*/
document.addEventListener("DOMContentLoaded", initVariantDescriptions);

/*
  SHOPIFY THEME EDITOR / SECTION RELOAD
*/
document.addEventListener("shopify:section:load", initVariantDescriptions);